export default "__VITE_ASSET__CjRxx$w0__"